import React from "react";
import { useTrailerCloseoutScan } from "./useTrailerCloseoutScan";
import { SimpleTextInputCard } from "sortation/components/SimpleTextInputCard";

export const TrailerCloseoutScan: React.FC = () => {
  const { scanConfig } = useTrailerCloseoutScan();

  return (
    <SimpleTextInputCard
      title={scanConfig.title}
      label={scanConfig.label}
      value={scanConfig.value}
      onSubmit={scanConfig.onSubmit}
      onChange={scanConfig.onChange}
      disabled={scanConfig.disabled}
    />
  );
};
